import {createSelector} from "reselect";
import minimization from "../../../../utils/Measure/minimization";

const measures = [
    { size: 8, name: 'b' },
    { size: 1024, name: 'kb' },
    { size: 1024, name: 'mb' },
    { size: 1024, name: 'gb' },
    { size: 1024, name: 'tb' },
]

const getSizeDescription = (baits) => {
    const { value, measure } = minimization(measures, baits, 'b');
    return `${value.toFixed(2)} ${measure}`;
}

const getInfoDocs = state => state.infoDocs;

export const containerSelector = createSelector(
    getInfoDocs,
    infoDocs => {
        const {list, ...other} = infoDocs;

        const mapList = list.map(({id, description, url, file_size}) => {
            const size = getSizeDescription(file_size);
            return {
                id, description, url, size
            }
        })

        return {
            ...other,
            list: mapList
        }
    }
)